import { QueryClient } from "@tanstack/react-query";

/**
 * The library's defaults are deliberately inverted here.
 *
 * `retry` is off because docs/architecture/error-protocol.md states the catalog does not
 * automatically retry requests, and a 503 is not a reason to repeat a write. Individual
 * queries opt in; nothing retries globally.
 *
 * Background refetching is off because every check the user can see has an explicit control
 * next to it. A silent refetch on window focus would contradict the "Check again" button and
 * could replace a visible failure with a different one the user never asked for.
 *
 * `throwOnError` is off so failures reach `ErrorNotice` in place, rather than escaping to the
 * root route's error boundary and replacing the whole page.
 */
export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: 0,
        throwOnError: false,
      },
      mutations: { retry: false },
    },
  });
}

export const queryClient = createAppQueryClient();
